import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-section bg-background-50 py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="常见问题"
            title="使用中的常见疑问"
            subtitle="下面整理了关于客户端、会员、弹幕与收藏的常见问题，点击问题即可展开查看解答。"
            align="center"
          />
        </Reveal>

        <div className="mt-10 space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <Reveal key={faq.q} delay={index * 50}>
                <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 text-left"
                    >
                      <span className="font-heading text-sm md:text-base font-bold text-foreground-900">
                        {faq.q}
                      </span>
                      <i
                        className={`shrink-0 text-xl text-primary-500 transition-transform duration-300 ${
                          isOpen ? "ri-subtract-line rotate-0" : "ri-add-line"
                        }`}
                      />
                    </button>
                  </h3>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-4 md:px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                        {faq.a}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}